module.exports = __webpack_public_path__ + "img/green-check.cacd7c63.svg";